import React, { useMemo } from 'react';
import PreloaderComponent from '#component/preloader';
import NotFoundMessage from '#component/general/not-found-message';
import CardView from './card';
import { CardsContainer, LoadingContainer } from './styles';
import { sortProjects } from '#helper';

const CardsView = props => {
  const { projects, account, loading, reloadProjects } = props;

  const sortedProjects = useMemo(() => sortProjects(projects), [projects]);

  if (loading) {
    return <PreloaderComponent />;
  }

  if (!loading && !projects.length) {
    return (
      <NotFoundMessage style={{ marginTop: -50 }}>
        No projects
      </NotFoundMessage>
    );
  }

  const ContainerComponent = loading ? LoadingContainer : CardsContainer;

  return (
    <ContainerComponent>
      {sortedProjects.map(p => (
        <CardView
          key={p.id}
          project={p}
          account={account}
          loading={loading}
          reloadProjects={reloadProjects}
        />
      ))}
    </ContainerComponent>
  );
};

export default CardsView;
